<template>
  <div
    class="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex justify-center overflow-y-auto items-start sm:items-center p-4 sm:p-6">
    <div class="rounded-xl shadow-xl w-full max-w-3xl relative md:w-[680px]">
      
      <!-- Close Button (appears after 3s with fade-in) -->
      <transition name="fade">
        <button
          v-if="showCloseButton"
          @click="$emit('close')"
          class="absolute top-[0px] right-[-5px] md:top-[-10px] md:right-[-12px] bg-black rounded-full p-2 w-8 h-8">
          <span class="text-white text-xl absolute top-[3px] right-[7px] md:top-[3px] md:right-[8px]">✕</span>
        </button>
      </transition>

      <!-- Form Render Target -->
      <div id="my-dynamic-form"></div>
    </div>
  </div>
</template>

<!-- <script>
export default {
  name: "EnquiryWidget",
  data() {
    return {
      baseUrl: "https://widget.yenepoya.prod.umsglobal.net/#/",
      widgetId: "7e85496e-0983-44a4-87f8-28a632fa2597",
      iframeUrl: null,
    };
  },
  created() {
    const query = this.$route.query;

    const utm_source = query.utm_source || "Organic";
    const utm_medium = query.utm_medium || "Website";
    const utm_campaign = query.utm_campaign || "Direct";

    const params = new URLSearchParams({
      color: "white",
      leadOwner: "JohnDoe",
      leadSource: utm_source,
      leadOrigin: "Website",
      academia_id: "1",
      university: "yenepoya",
      widget_id: this.widgetId,
      utm_source,
      utm_medium,
      utm_campaign
    });

    this.iframeUrl = `${this.baseUrl}?${params.toString()}`;
  }
};
</script> -->
<script>
export default {
  name: "EnquiryWidget",
  data() {
    return {
      showCloseButton: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadWidget();

      // Show close button after 3 seconds
      setTimeout(() => {
        this.showCloseButton = true;
      }, 2000);
    });
  },
  methods: {
    loadWidget() {
      const oldScript = document.getElementById("__DF_SCRIPT__");
      if (oldScript) oldScript.remove();

      const script = document.createElement("script");
      script.id = "__DF_SCRIPT__";
      script.src =
        "https://ams.dashboard.usdcglobal.com/libs/form/form-renderer-sdk.iife.js"

      script.dataset.target = "my-dynamic-form";
      script.dataset.universityId = "d345a03a-cfd7-429d-8c3b-c8ff5e996c9d";
      script.dataset.mode = "embedded";
      script.dataset.position = "center";
      script.dataset.type = "WIDGET";
      script.dataset.widgetId = "widget-eb6f67db-80b0-411e-bcb7-e5763f8d9939";

      document.body.appendChild(script);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>